import React, {useState, useRef} from 'react';

import icons from "../helpers/icons";
import {postForm} from '../api';

const Uploadable = (props) => {

    const reloadBilde = props.reloadBilde;
    const action = props.action;
    const appendFormData = props.appendFormData;

    const inputRef = useRef(null);
    const [uploadFile, setUploadFile] = useState(null)
    const [isUploading, setIsUploading] = useState(false);
    const [error, setError] = useState(null);

    const text = () => {
        return uploadFile ? `Valgt billede: ${uploadFile.name}` : ""
    }

    const onChangeHandler= ({target}) => {
        if (target.files && target.files.length > 0) {
            const file = target.files[0];
            setError(null);
            setUploadFile(file);
        }
    }

    function uploadFileToServer(formdata) {
        setError(null);
        setIsUploading(true);
        postForm(action, formdata)
            .then((data) => {
                setIsUploading(false);
                setUploadFile(null);
                inputRef.current.value = "";
                reloadBilde();
            })
            .catch((err) => {
                setIsUploading(false);
                setUploadFile(null);
                inputRef.current.value = "";
                setError(err.message);
            });
    }

    const onSubmitHandler = (event) => {
        event.preventDefault();
        const formdata = new FormData();
        formdata.append('file', uploadFile);
        if (appendFormData !== null && appendFormData !== undefined) {
            appendFormData(formdata);
        }
        uploadFileToServer(formdata);
    };

    const onUploadClick = (event) => {
        event.preventDefault();
        inputRef.current.click();
    };


    const uploadFormClass = uploadFile !== null || error !== null ? "upload-form" : "";
    const buttonLabel = isUploading ? "Uploading" : "Start upload";
    const uploadButtonFormClass = isUploading ? "upload-button-disabled" : "upload-button";
    return(
        <div className="upload-button">

            <form method="post" onSubmit={onSubmitHandler} className={uploadFormClass}>

                    <label htmlFor="upload">
                        <span className="filename">{text()}</span>
                        { error !== null && <span className="error">{error}</span> }
                        <img onClick={onUploadClick} className="icon" src={icons.cam} alt="Last opp billede"/>
                    </label>
                    <input id="upload"
                           type="file"
                           name="upload"
                           accept="image/png, image/jpeg, image/png, image/tiff"
                           style={{"display": "none"}}

                           onChange={onChangeHandler}
                           ref={inputRef}
                    />


                { uploadFile &&
                    <button  disabled={ isUploading ? true : false } type="submit" className={uploadButtonFormClass}>
                        {buttonLabel}
                    </button>
                }
            </form>


        </div>
    )
}

export default Uploadable;

